export const shouldShowEmailLogs = () =>
  window.Reqres.request('hasFeature', 'mako', 'email_logs');
